import HeaderTitlePage from "./HeaderTitlePage";

export default HeaderTitlePage;